import general from "@/js/store/default";
import offline from "@/js/store/offline";
import {isOffline} from "@/js/utils";

let store = isOffline() ? offline : general;
export default store;
